import React from "react";

const LOGO_URL = "/logo-universa.png";

// Brand logo — transparent line-art wordmark lockup.
export const Logo = ({ height = 52, className = "" }) => (
  <img
    src={LOGO_URL}
    alt="Universa Flow"
    style={{ height }}
    className={`w-auto object-contain ${className}`}
  />
);
